import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

// Actions
import { SetLoading, SetBanner, SetIncidentUIState, SetHTTPErrors, ClearHTTPErrors } from './ui.actions';

// Models
import { UIStateModel } from '@app/models/ui.model';

@State<UIStateModel>({
  name: 'ui',
  defaults: {
    app: {
      banner: void 0,
    },
    incidentUI: {
      isEditModeActive: false,
    },
    loading: false,
    hasHTTPErrors: false,
    httpErrors: [],
  },
})
@Injectable()
export class UIState {
  @Selector()
  static getLoading(state: UIStateModel): UIStateModel['loading'] {
    return state.loading;
  }

  @Selector()
  static getHasHTTPErrors(state: UIStateModel): UIStateModel['hasHTTPErrors'] {
    return state.hasHTTPErrors;
  }

  @Selector()
  static getHTTPErrorMessages(state: UIStateModel): string[] {
    const httpErrors = state.httpErrors ?? [];
    return httpErrors.map((httpError) => httpError.message);
  }

  @Selector()
  static getAppDetails(state: UIStateModel): UIStateModel['app'] {
    return state.app;
  }

  @Selector()
  static getIncidentUi(state: UIStateModel): UIStateModel['incidentUI'] {
    return state.incidentUI;
  }

  @Action(SetLoading)
  setLoading(ctx: StateContext<UIStateModel>, { payload }: SetLoading) {
    ctx.patchState({ loading: payload });
  }

  @Action(SetBanner)
  setBanner(ctx: StateContext<UIStateModel>, { payload }: SetBanner) {
    const { app } = ctx.getState();

    ctx.patchState({
      app: {
        ...app,
        banner: payload,
      },
    });
  }

  @Action(SetIncidentUIState)
  setIncidentUIState(ctx: StateContext<UIStateModel>, { payload }: SetIncidentUIState) {
    ctx.patchState({ incidentUI: payload });
  }

  @Action(SetHTTPErrors)
  setHTTPErrors(ctx: StateContext<UIStateModel>, { payload }: SetHTTPErrors) {
    ctx.patchState({ httpErrors: payload });
  }

  @Action(ClearHTTPErrors)
  clearHTTPErrors(ctx: StateContext<UIStateModel>) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { hasHTTPErrors, httpErrors, ...newState } = ctx.getState();
    ctx.setState({ ...newState, hasHTTPErrors: false, httpErrors: [] });
  }
}
